import React, { useEffect } from 'react';
import { Cms } from 'components';
import { Hero, CtaImageFull, ArticleThumb } from 'layouts';
import { useAppDispatch, useList, usePage } from 'hooks';
import Loading from 'features/loading/Loading';
import type { AboutPage } from 'services/page/types';
import { addOne as addLoading, removeOne as removeLoading } from 'features/loading/loadingSlice';
import { pageService } from 'services';
import { Props as ArticleThumbType } from 'layouts/ArticleThumb/ArticleThumb';
import { useTranslation } from 'react-i18next';
import { Page } from 'helpers/enums';

const About = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['text']);
  const articles = useList<ArticleThumbType>(3);
  const { hero, content, cta }: AboutPage = usePage<AboutPage>(Page.about);

  useEffect(() => {
    (async () => {
      try {
        dispatch(addLoading({ id: 'FETCH_ARTICLES' }));

        const params = {
          records: articles.perPage,
          page: articles.page,
          sortField: 'a.created',
          sortDirection: 'DESC',
        };

        const response = await pageService.articles(params);

        articles.handleFetch(response);
      } catch (error) {
        console.log('FETCH_ARTICLES');
      } finally {
        dispatch(removeLoading('FETCH_ARTICLES'));
      }
    })();
  }, [articles.shouldUpdate]);

  return (
    <Loading items={['FETCH_PAGE', 'FETCH_ARTICLES']}>
      {hero && <Hero {...hero} />}
      {content && (
        <section className="my-64 xl:my-96">
          <div className="container">
            <Cms>
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </Cms>
          </div>
        </section>
      )}
      {cta && <CtaImageFull {...cta} />}
      {!!articles.items.length && (
        <section className="my-64 xl:my-96">
          <div className="container">
            <h3 className="font-bold font-headings text-black text-28 xl:text-40 leading-34 xl:leading-50 text-center mb-24 xl:mb-32">
              {t('text:articles')}
            </h3>
            <div className="row -mb-16 lg:-mb-24">
              {articles.items.map((item) => (
                <div className="col md:w-1/2 xl:w-1/3 mb-16 lg:mb-24" key={item.id}>
                  <ArticleThumb {...item} />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </Loading>
  );
};

export default About;
